import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoute } from '@/auth/AuthRoute';
import { AuthErrorBanner } from '@/components/ui/AuthErrorBanner';
import { Login } from '@/pages/Login';
import { PickupsApp } from '@/PickupsApp';
import { useIdleLogoff } from '@/lib/idle-logoff';

/**
 * Router shell. /login is the sign-in wall; /login/callback is where the MSAL redirect lands (the
 * redirect was already processed in main.tsx before render, so we just bounce to /). Everything
 * else is guarded by AuthRoute and renders the authenticated PickupsApp (which owns the AppShell +
 * the activeId/onNavigate page switch - no nested routes inside the shell).
 */
export default function App() {
  useIdleLogoff();
  return (
    <>
      <AuthErrorBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<Navigate to="/" replace />} />
        <Route
          path="/*"
          element={
            <AuthRoute>
              <PickupsApp />
            </AuthRoute>
          }
        />
      </Routes>
    </>
  );
}
